export enum Authority {
  // 超级管理员
  ADMIN = 'ROLE_ADMIN',
  // 公司管理员
  COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN',
  USER = 'ROLE_USER',
}
